import * as Types from "../../apollo/graphql.generated";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {};
export type GetCollectionForSuccessModalQueryVariables = Types.Exact<{
  collectionId: Types.Scalars["String"];
}>;

export type GetCollectionForSuccessModalQuery = {
  getPublicCollection: {
    __typename: "Collection";
    name: string;
    chainId: number;
    creatorEns: string | null;
    collectionType: Types._CollectionType;
    onChainBaseUri: string | null;
    openSeaCollectionUrl: string | null;
    address: string;
    reveal: boolean | null;
    editions: Array<{
      __typename: "EditionToken";
      image: string;
      animation: string | null;
      size: number;
      nonTransferable: boolean | null;
    }> | null;
    creatorAddresses: Array<{
      __typename: "EvmAddress";
      address: string;
      name: string | null;
    }> | null;
  };
};

export const GetCollectionForSuccessModalDocument = gql`
  query GetCollectionForSuccessModal($collectionId: String!) {
    getPublicCollection(collectionId: $collectionId) {
      name
      chainId
      editions {
        image
        animation
        size
        nonTransferable
      }
      creatorAddresses {
        address
        name
      }
      creatorEns
      collectionType
      onChainBaseUri
      openSeaCollectionUrl
      address
      reveal
    }
  }
`;

/**
 * __useGetCollectionForSuccessModalQuery__
 *
 * To run a query within a React component, call `useGetCollectionForSuccessModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionForSuccessModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionForSuccessModalQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useGetCollectionForSuccessModalQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCollectionForSuccessModalQuery,
    GetCollectionForSuccessModalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCollectionForSuccessModalQuery,
    GetCollectionForSuccessModalQueryVariables
  >(GetCollectionForSuccessModalDocument, options);
}
export function useGetCollectionForSuccessModalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCollectionForSuccessModalQuery,
    GetCollectionForSuccessModalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCollectionForSuccessModalQuery,
    GetCollectionForSuccessModalQueryVariables
  >(GetCollectionForSuccessModalDocument, options);
}
export type GetCollectionForSuccessModalQueryHookResult = ReturnType<
  typeof useGetCollectionForSuccessModalQuery
>;
export type GetCollectionForSuccessModalLazyQueryHookResult = ReturnType<
  typeof useGetCollectionForSuccessModalLazyQuery
>;
export type GetCollectionForSuccessModalQueryResult = Apollo.QueryResult<
  GetCollectionForSuccessModalQuery,
  GetCollectionForSuccessModalQueryVariables
>;
